import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";

const Search = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { search } = useSelector((state) => ({ ...state }));
  const { text } = search;

  const [isSearchVisible, setSearchVisible] = useState(false);

  const handleChange = (e) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: e.target.value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("./shop?" + text);
  };

  const toggleSearch = () => {
    setSearchVisible(!isSearchVisible);
  };

  // ✅ Reset search text on route change
  useEffect(() => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
  }, [location.pathname]);

  return (
    <div className="search-container">
      {!isSearchVisible && (
        <span
          className="search-text"
          onClick={toggleSearch}
          style={{
            color: "#939392",
            fontSize: "12px",
            marginTop: "20px",
            textAlign: "center",
          }}
        >
          ค้าหาสินค้า
        </span>
      )}
      <SearchOutlined
        onClick={toggleSearch}
        className="search-icon"
        style={{ color: "#000000", fontSize: "20px" }}
      />
      {isSearchVisible && (
        <form onSubmit={handleSubmit} className="search-form">
          <input
            onChange={handleChange}
            type="search"
            className="form-control search-input"
            value={text}
            placeholder="Search..."
          />
        </form>
      )}
    </div>
  );
};

export default Search;
